/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeoDataBBox
 */
export interface GeoDataBBox {
    /**
     * 
     * @type {Array<number>}
     * @memberof GeoDataBBox
     */
    extent: Array<number>;
}

/**
 * Check if a given object implements the GeoDataBBox interface.
 */
export function instanceOfGeoDataBBox(value: object): value is GeoDataBBox {
    if (!('extent' in value) || value['extent'] === undefined) return false;
    return true;
}

export function GeoDataBBoxFromJSON(json: any): GeoDataBBox {
    return GeoDataBBoxFromJSONTyped(json, false);
}

export function GeoDataBBoxFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoDataBBox {
    if (json == null) {
        return json;
    }
    return {
        
        'extent': json['extent'],
    };
}

export function GeoDataBBoxToJSON(json: any): GeoDataBBox {
    return GeoDataBBoxToJSONTyped(json, false);
}

export function GeoDataBBoxToJSONTyped(value?: GeoDataBBox | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'extent': value['extent'],
    };
}

